import React from 'react'

import influencerData from '../../data-influencer/healthyinsideout'
import PageBuilder from '../PageBuilder'
import PageLayout from './PageLayout'

const HealthyInsideOut = () => (
    <PageBuilder influencerData={influencerData}>
        <PageLayout />
    </PageBuilder>
)

export default HealthyInsideOut
